// extracted by mini-css-extract-plugin
export default {"input":"src-components-Base-DesensitizationInput-input--eKxQ0"};